import { useOuterClick } from '@helpers/useOuterClick';
import { useState } from 'react';

export interface HoverItem {
  onClick: () => void;
  className?: string;
  visible?: boolean
  label: string;
}

interface HoverMenuProps {
  children: React.ReactNode;
  className?: string;
  horizontal?: boolean;
  disabled?: boolean;
  items: HoverItem[];
};

export function HoverMenu({ items, children, className, horizontal, disabled }: HoverMenuProps) {
  const [isOpen, setIsOpen] = useState(false);

  const innerRef = useOuterClick(() => closeMenu());
  const openMenu = () => setIsOpen(true);
  const closeMenu = () => setIsOpen(false);

  const visibleItems = items.filter(i => i.visible !== false);

  return (
    <div className={`${className} relative`} onClick={openMenu} ref={innerRef}>
      {children}

      {isOpen && !disabled && (
        <div className={`${horizontal && 'horizontal'} hover-menu`}>
          {visibleItems.map((item, index) => (
            <button
              onClick={(e) => {
                e.stopPropagation();
                item.onClick();
                closeMenu();
              }}
              className={`${item.className} ramp-in hover-item`}
              key={index}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}